/** Supabase conversations use `id`; legacy UI expects `_id`. */

export function conversationRoomId(c: any): string {
  if (!c || typeof c !== 'object') return '';
  const v = c._id ?? c.id;
  return v != null ? String(v).trim() : '';
}

export function normalizeConversation(conv: any) {
  if (!conv || typeof conv !== 'object') return conv;
  const id = conv._id ?? conv.id;
  if (id == null) return conv;

  let participants = conv.participants;
  if ((!participants || !participants.length) && Array.isArray(conv.members)) {
    participants = conv.members
      .map((m: any) => {
        const p = m.profiles || m.profile;
        if (!p) return null;
        const pid = p.id ?? p._id;
        if (pid == null) return null;
        return {
          _id: String(pid),
          id: String(pid),
          username: p.username,
          name: p.name,
          email: p.email,
          avatar: p.avatar_url || p.avatar,
        };
      })
      .filter(Boolean);
  } else if (Array.isArray(participants)) {
    participants = participants.map((p: any) => {
      if (!p) return p;
      const pid = p._id ?? p.id;
      if (pid == null) return p;
      return {
        ...p,
        _id: String(pid),
        id: String(pid),
        avatar: p.avatar || p.avatar_url,
      };
    });
  }

  const sid = String(id);
  return { ...conv, _id: sid, id: sid, participants: participants || conv.participants || [] };
}
